import { IonApp } from '@ionic/react'
import { useEffect, useMemo } from 'react'

import { Conversation } from './components/Conversation'
import { DevTenantPicker } from './components/DevTenantPicker'
import { Unavailable } from './components/Unavailable'
import { UpdatePrompt } from './components/UpdatePrompt'
import { watchKeyboard } from './lib/native'
import { resolveSlug } from './lib/tenant'

/**
 * The app is one business's app, and this decides which.
 *
 * There is no route table and no navigation stack, which is not a shortcut: a
 * booking is one conversation, and the server hands back one step at a time.
 * Adding a router would put a second idea of "where am I" next to the flow's,
 * and the two would eventually disagree — a back button that unwinds a URL
 * while the session stays where it was.
 */
export function App() {
  // Resolved once. The slug comes from the hostname or the build, neither of
  // which changes while the app is open.
  const slug = useMemo(() => resolveSlug(), [])

  useEffect(() => watchKeyboard(), [])

  return (
    <IonApp>
      {slug ? (
        <Conversation slug={slug} />
      ) : import.meta.env.DEV ? (
        <DevTenantPicker />
      ) : (
        /*
         * No tenant, and nothing to say about why.
         *
         * In production this means the app was opened from a host that names no
         * business — a bare origin, or a system subdomain. It gets the same
         * neutral notice a suspended business gets, for the same reason: the
         * page is being read by that business's customers, and what we would be
         * explaining is our commercial relationship with them.
         */
        <Unavailable />
      )}
      <UpdatePrompt />
    </IonApp>
  )
}
